import { render, staticRenderFns } from "./SubAssetItem.vue?vue&type=template&id=2fb18c96&"
import script from "./SubAssetItem.vue?vue&type=script&lang=js&"
export * from "./SubAssetItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports